export default class LinkedItem {
  next: this | null = null
  prev: this | null = null
}
